import { useMutation, useQuery } from "@tanstack/react-query";
import { baseApi } from "./baseApi";
import { engineApi } from "./engineApi";

export const useGetIndicators = (broker_id?: string) => {
  return useQuery({
    queryKey: ["canvas-indicators", broker_id],
    queryFn: async () => {
      const url = broker_id
        ? `/canvas_get_indicators?broker_id=${broker_id}`
        : `/canvas_get_indicators`;
      const response = await baseApi.get(url);
      return response;
    },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};

export const useGetLogics = (broker_id?: string) => {
  return useQuery({
    queryKey: ["canvas-logics", broker_id],
    queryFn: async () => {
      const url = broker_id
        ? `/canvas_get_logics?broker_id=${broker_id}`
        : `/canvas_get_logics`;
      const response = await baseApi.get(url);
      return response;
    },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};

export const useGetActions = (broker_id?: string, enabled?: boolean) => {
  return useQuery({
    queryKey: ["canvas-actions", broker_id],
    queryFn: async () => {
      const url = broker_id
        ? `/canvas_get_actions?broker_id=${broker_id}`
        : `/canvas_get_actions`;
      const response = await baseApi.get(url);
      return response;
    },
    enabled: enabled,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};

export const useGetDatas = (broker_id?: string) => {
  return useQuery({
    queryKey: ["canvas-datas", broker_id],
    queryFn: async () => {
      const response = await baseApi.get(
        `/canvas_get_datas?broker_id=${broker_id}`,
      );
      return response;
    },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};

export const useGetPatterns = () => {
  return useQuery({
    queryKey: ["canvas-patterns"],
    queryFn: async () => {
      const response = await baseApi.get(`/canvas_get_patterns`);
      return response;
    },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};

export const useGetChartPatterns = () => {
  return useQuery({
    queryKey: ["canvas-chart-patterns"],
    queryFn: async () => {
      const response = await baseApi.get(`/canvas_get_chart_patterns`);
      return response;
    },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};
